export default () => ({
  init() {
    const bundleCTA = document.querySelector('.pdp-bundle-cta');
    if (!bundleCTA) return;

    //handles dynamic linking between variants/component visuals/text/discount
    const dynamicCTALink = bundleCTA.getAttribute('data-dynamic-link');
    if (!dynamicCTALink) return;

    this.dynamicLinking();
  },
  dynamicLinking() {
    //any selections after load
    const variantSelectors = document.querySelectorAll('variant-selects input');
    for (let i = 0; i < variantSelectors.length; i++) {
      variantSelectors[i].addEventListener('change', function () {
        dynamicLinkChange();
      });
    }

    document.addEventListener('change', function () {
      dynamicLinkChange();
    });

    dynamicLinkChange();
  },
});

function dynamicLinkChange() {
  const bundleCTA = document.querySelector('.pdp-bundle-cta');
  if (!bundleCTA) return;

  const bundleOffer = document.querySelector('.pdp-bundle-offer');
  if (!bundleOffer) return;

  //handles dynamic linking between variants/component visuals/text/discount
  const dynamicCTALink = bundleCTA.getAttribute('data-dynamic-link');
  if (!dynamicCTALink) {
    //if no dynamic link means link is static and handle it
    if (bundleOffer.classList.contains('hidden')) bundleOffer.classList.remove('hidden');
    const bundleCtaAnchor = bundleCTA.querySelector("a");
    if(!bundleCtaAnchor) return;
    let newHref = bundleCtaAnchor.getAttribute("data-href");
    bundleCtaAnchor.setAttribute("href", newHref);
    return;
  }

  const currentVariant = document.querySelector('variant-selects input:checked');
  if (!currentVariant) return;

  const currentVariantId = currentVariant.getAttribute('data-option-value-id');
  if (!currentVariantId) return;

  const dynamicLinkArray = dynamicCTALink.split(',');


  let foundDynamicVariant = false;
  for (let j = 0; j < dynamicLinkArray.length; j++) {
    if (dynamicLinkArray[j].indexOf(currentVariantId) >= 0) foundDynamicVariant = dynamicLinkArray[j];
  }
  if (foundDynamicVariant !== false) {
    //handle logic to dynamically change cta url

    bundleOffer.setAttribute("data-variant-id", currentVariantId);
    const bundleCtaAnchor = bundleCTA.querySelector("a");

    let foundParts = foundDynamicVariant.split("|");

    if(!bundleCtaAnchor) return;
    let newHref = bundleCtaAnchor.getAttribute("data-href");
    if(foundParts.length >= 2)
        newHref = newHref.replace("%varid%", foundParts[1]);
    if(foundParts.length >= 3)
        newHref = newHref.replace("%vardiscount%", foundParts[2]);
    bundleCtaAnchor.setAttribute("href", newHref);
    //unhide if hidden from another variant
    if (bundleOffer.classList.contains('hidden')) bundleOffer.classList.remove('hidden');
  } else {
    //hide if not available in custom url
    if (!bundleOffer.classList.contains('hidden')) bundleOffer.classList.add('hidden');

     bundleOffer.removeAttribute("data-variant-id");
  }
}
